import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './LandingPage.css';
import Header from './Header';
import ProductBox from './ProductBox';
import InfiniteScroll from 'react-infinite-scroll-component';
import debounce from 'lodash/debounce';
import { v4 as uuidv4 } from 'uuid';
import Footer from './Footer';
import { Helmet } from "react-helmet";
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Searchbar from './Searchbar';
import TopDiscountedCarousel from './TopDiscountedCarousel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLink, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';

const LandingPage = () => {
    const { t, i18n } = useTranslation();

    const [products, setProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [featuredProducts, setFeaturedProducts] = useState([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [search, setSearch] = useState('');

    const fetchCategorizedProducts = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/product/categories`);
            setFeaturedProducts(response.data);
        } catch (error) {
            console.error('Error fetching categorized products:', error);
        }
    };

    useEffect(() => {
        fetchCategorizedProducts(); // Fetch featured products on mount
    }, []); // Empty dependency to run only once on mount


    const CategorySlider = ({ title, description, link, data, sliderSettings }) => (
        <div className={`slider-container ${title.toLowerCase()}`}>
            <div className="slider-header">
            <Link to={link}>
            <h2 className='hover:text-primary text-lg text-[rgb(62,43,205)] category-title'>{title} <FontAwesomeIcon icon={faExternalLink} className="ml-2" /></h2>
            </Link>
            <p className='text-sm'>{description}</p>
                {/* <Link to={link} className="see-all">{t('landingPage.seeAll')}</Link> */}
            </div>
            <div className="carousel carousel-center space-x-4 p-4 overflow-x-auto w-full">
                {data.map(product => (
                    <div key={product._id} className="carousel-item px-4 flex justify-center items-stretch">
                        <ProductBox product={product} />
                    </div>
                ))}
            </div>
        </div>
    );

    const FeaturedProducts = ({ data }) => {
        const sliderSettings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
                { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 1 } },
                { breakpoint: 700, settings: { slidesToShow: 2, slidesToScroll: 1 } },
                { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } }
            ]
        };

        return (
            <div className="featured-products">
                {data.skincare && (
                    <CategorySlider title={t('landingPage.featuredSkincare')} description={t('featuredSkincare.description')} link="/skincare" data={data.skincare} sliderSettings={sliderSettings} />
                )}
                 {data.makeup && (
                    <CategorySlider title={t('landingPage.featuredMakeup')} description={t('featuredMakeup.description')} link="/makeup" data={data.makeup} sliderSettings={sliderSettings} />
                )}
                {data.fragrance && (
                    <CategorySlider title={t('landingPage.featuredFragrances')} description={t('featuredFragrances.description')} link="/fragrances" data={data.fragrance} sliderSettings={sliderSettings} />
                )}
                {data.phone && (
                    <CategorySlider title={t('landingPage.featuredPhones')} description={t('featuredPhones.description')} link="/phones" data={data.phone} sliderSettings={sliderSettings} />
                )}
                 {data.tablet && (
                    <CategorySlider title={t('landingPage.featuredTablets')} description={t('featuredTablets.description')} link="/tablets" data={data.tablet} sliderSettings={sliderSettings} />
                )}
              
                {/* Additional category sliders */}
            </div>
        );
    };

    return (
        <div className="container">
            <Helmet>
                <html lang={i18n.language} />
                <title>{i18n.language === 'ar' ? 'الصفحة الرئيسية | PriceAlertz' : 'Home Page | PriceAlertz'}</title>
                <meta name="description" content={i18n.language === 'ar' ? 'ابحث عن...' : 'Search for...'} />
                <meta name="keywords" content={i18n.language === 'ar' ? 'أفضل الأسعار...' : 'Best prices...'} />
                <meta name="robots" content="index, follow" />
            </Helmet>

            <div className='header-menu-container'>
                <Header />
            </div>

            <Searchbar 
            placeholder={t('searchbar.landingPage')} 
            onSearchSubmit={(value) => {
                // handle the actual search logic here
                console.log('User searched:', value);
                // maybe call your API or filter state, etc.
              }}
            />

            {/* {search.trim() !== '' && filteredProducts.length > 0 && (
                <div className="search-products">
                    <h2>{t('landingPage.searchResults')}</h2>
                    <InfiniteScroll
                        dataLength={filteredProducts.length}
                        next={() => setPage(prevPage => prevPage + 1)}
                        hasMore={hasMore}
                        loader={<p>{t('general.loading')}</p>}
                        endMessage={<p>{t('general.noMoreProducts')}</p>}
                    >
                        <div className="product-list" id="scrollable-container">
                            {filteredProducts.map(product => (
                                <div key={uuidv4()} className='product'>
                                    <ProductBox product={product} />
                                </div>
                            ))}
                        </div>
                    </InfiniteScroll>
                </div>
            )} */}

            <TopDiscountedCarousel />

            <FeaturedProducts data={featuredProducts} />

            <Footer />
        </div>
    );
};

export default LandingPage;